


















































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { VForm } from "@/common/vuetify_types";
import { Shift } from "@/api";
import * as validation from "@/tool/validation";

@Component
export default class ShiftForm extends Vue {
  @Ref("form") form!: VForm;

  @Prop({ required: false, default: null }) readonly initialData!: Shift | null;

  valid = false;
  loading = false;

  shiftData: Partial<Shift> = {
    shift: "",
    startTime: "",
    endTime: "",
  };

  rules = {
    required: validation.requiredString,
  };

  get isEdit(): boolean {
    return !!this.initialData;
  }

  @Watch("initialData", { immediate: true })
  onInitialDataChanged(newVal: Shift | null) {
    if (newVal) {
      this.shiftData = { ...newVal };
    } else {
      this.shiftData = { shift: "", startTime: "", endTime: "" };
    }
  }

  close() {
    this.form?.resetValidation();
    this.$emit("close");
  }

  async save() {
    if (!this.form.validate()) return;

    this.loading = true;
    try {
      if (this.isEdit) {
        await this.$store.dispatch(
          "shift/updateShift",
          this.shiftData as Shift,
        );
      } else {
        await this.$store.dispatch("shift/addShift", this.shiftData as Shift);
      }
      this.form.resetValidation();
      // Also refetch shifts to make sure the list is updated, though addShift/updateShift might already update state
      await this.$store.dispatch("shift/fetchShifts");
      this.$emit("save");
    } catch (e) {
      console.error(e);
      this.$store.dispatch(
        "alert/warning",
        "An error occurred while saving the shift.",
      );
    } finally {
      this.loading = false;
    }
  }
}
